/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc). To make a column queryable by index — including boolean/nullable columns — add a single-column Postgres index and re-run `sf dc`; do not hand-edit generated files.
 */

import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { ConsumableSourcePreferenceBase } from 'shared/dbo/ConsumableSourcePreference';

export interface ConsumableSourcePreferenceIndexedDb {
	id: string;
	consumableId: string;
	sourceId: string;
	preferenceOrder: number;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isConsumableSourcePreferenceIndexedDb = (obj: unknown): obj is ConsumableSourcePreferenceIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (hasPropOfType<{ deleted: boolean }>(obj, 'deleted', 'boolean') && obj.deleted) {
		return true;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ consumableId: unknown }>(obj, 'consumableId') || !(typeof obj.consumableId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ sourceId: unknown }>(obj, 'sourceId') || !(typeof obj.sourceId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ preferenceOrder: unknown }>(obj, 'preferenceOrder') || !(typeof obj.preferenceOrder === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: ConsumableSourcePreferenceBase): ConsumableSourcePreferenceIndexedDb => ({
	id: obj.id.toString(),
	consumableId: obj.consumableId.toString(),
	sourceId: obj.sourceId.toString(),
	preferenceOrder: Number(obj.preferenceOrder),
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: ConsumableSourcePreferenceIndexedDb): ConsumableSourcePreferenceBase => ({
	id: UUID.fromString(obj.id),
	consumableId: UUID.fromString(obj.consumableId),
	sourceId: UUID.fromString(obj.sourceId),
	preferenceOrder: BigInt(obj.preferenceOrder),
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdConsumableSourcePreference: LocalDatabaseTableDefinition<ConsumableSourcePreferenceBase, ConsumableSourcePreferenceIndexedDb> = {
	tableName: 'consumableSourcePreferences',
	indexColumns: ['consumableId'],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
